const remove_drawer_additional_products = (event, checked, id)=>{
  if(checked){
    event.preventDefault()
    const items = document.querySelectorAll("cart-remove-button[data-drawer__switch_prod]");
    items.forEach((item)=>{
      const item_id = item.getAttribute("data-drawer__switch_prod");
      if(id == item_id){
        item.click();
      }
    })
  }
}